import Header from "../components/Header";
import Title from "../components/Title";
import {
  webapp,
  webdes,
  cloud,
  hand,
  pens,
  planet,
  car,
  cars,
} from "../assets/icons/index";
import Footer from "../components/Footer";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  CAR_RENTAL_PATH,
  CLOUDHOSTING_PATH,
  CONSULTANCY_PATH,
  CORPORATE_PATH,
  FLEET_MANAGMENT_PATH,
  SEO_PATH,
  WEBAPPDEV_PATH,
  WEBDESIGN_PATH,
} from "../Routes/paths";

interface ServicesProps {}

const Services = ({}: ServicesProps) => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <main
        className={`w-full ${
          i18n.language === "en" ? "font-Poppins" : "font-Almarai"
        }`}
      >
        {/* hero section  *****************************/}
        <Title title={t("Services")} subtitle={t("Services")} />

        {/* Our Services ***********************************/}
        <section className="my-[100px] px-[20px] lg:px-0 w-full flex flex-col gap-10 ">
          {/* first row ***************/}
          <div className="flex flex-col gap-8 lg:gap-0 lg:flex-row lg:items-center lg:justify-around ">
            <div
              onClick={() => navigate(`${WEBDESIGN_PATH}`)}
              className="flex flex-col items-center cursor-pointer"
            >
              <img src={webdes} alt="" />
              <p className="font-[700] text-[18px] lg:text-[20px]">
                {t("Web Design")}
              </p>
              <p className="lg:texr-[14px] max-w-[330px] text-center">
                {t(
                  "Website design that is cost effective, of an international quality and easy to browse."
                )}
              </p>
            </div>

            <div
              onClick={() => navigate(`${CLOUDHOSTING_PATH}`)}
              className="flex flex-col items-center cursor-pointer"
            >
              <img src={cloud} alt="" />
              <p className="font-[700] text-[18px] lg:text-[20px]">
                {t("Cloud Hosting")}
              </p>
              <p className="lg:texr-[14px] max-w-[330px] text-center">
                {t(
                  "Designed to meet the diverse needs of businesses of all sizes with good prices"
                )}
              </p>
            </div>

            <div
              onClick={() => navigate(`${WEBAPPDEV_PATH}`)}
              className="flex flex-col items-center cursor-pointer"
            >
              <img src={webapp} alt="" />
              <p className="font-[700] text-[18px] lg:text-[20px]">
                {t("Web Application Development")}
              </p>
              <p className="lg:texr-[14px] max-w-[330px] text-center ">
                {t(
                  "Custom built web application development, latest technologies at optimal rates."
                )}
              </p>
            </div>
          </div>

          {/* second row  ****************/}
          <div className="flex flex-col gap-8 lg:gap-0 lg:flex-row lg:items-center lg:justify-around ">
            <div
              onClick={() => navigate(`${CORPORATE_PATH}`)}
              className="flex flex-col items-center cursor-pointer"
            >
              <img src={pens} alt="" />
              <p className="font-[700] text-[18px] lg:text-[20px]">
                {t("Corporate Identity")}
              </p>
              <p className="lg:texr-[14px] max-w-[330px] text-center">
                {t(
                  "Logo designing, business cards, letterheads, bridge between strategy and creativity."
                )}
              </p>
            </div>

            <div
              onClick={() => navigate(`${SEO_PATH}`)}
              className="flex flex-col items-center cursor-pointer"
            >
              <img src={planet} alt="" />
              <p className="font-[700] text-[18px] lg:text-[20px]">
                {t("SEO Services")}
              </p>
              <p className="lg:texr-[14px] max-w-[330px] text-center">
                {t(
                  "To be or not to be, that is the SEO question. Yes, to have a website or to have and be invisible."
                )}
              </p>
            </div>

            <div
              onClick={() => navigate(`${CONSULTANCY_PATH}`)}
              className="flex flex-col items-center cursor-pointer"
            >
              <img src={hand} alt="" />
              <p className="font-[700] text-[18px] lg:text-[20px]">
                {t("Consultancy")}
              </p>
              <p className="lg:texr-[14px] max-w-[330px] text-center ">
                {t(
                  "Startup advisory services, how to optimize your identity, online performance."
                )}
              </p>
            </div>
          </div>

          {/* third row  **************/}
          <div className="flex flex-col gap-8 lg:gap-0 lg:flex-row lg:items-center lg:justify-around ">
            <div
              onClick={() => navigate(`${CAR_RENTAL_PATH}`)}
              className="flex flex-col items-center cursor-pointer"
            >
              <img src={car} alt="" />
              <p className="font-[700] text-[18px] lg:text-[20px]">
                {t("Car Rental System")}
              </p>
              <p className="lg:texr-[14px] max-w-[330px] text-center">
                {t(
                  "Send your car rental business to the next level of professional car rental system."
                )}
              </p>
            </div>

            <div
              onClick={() => navigate(`${FLEET_MANAGMENT_PATH}`)}
              className="flex flex-col items-center cursor-pointer"
            >
              <img src={cars} alt="" />
              <p className="font-[700] text-[18px] lg:text-[20px]">
                {t("Fleet Management System")}
              </p>
              <p className="lg:texr-[14px] max-w-[330px] text-center">
                {t(
                  "To be or not to be, that is the SEO question. Yes, to have a website or to have and be invisible."
                )}
              </p>
            </div>

            <div className="opacity-0 flex flex-col items-center ">
              <img src={hand} alt="" />
              <p className="font-[700] text-[18px] lg:text-[20px]">
                {t("Consultancy")}
              </p>
              <p className="lg:texr-[14px] max-w-[330px] text-center ">
                {t(
                  "Enhance the efficiency of your fleet with our Fleet Management System."
                )}
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default Services;
